package com.devi3east.bashbuddy.cart.data.repositories

import com.devi3east.bashbuddy.cart.data.api.CartApi
import com.devi3east.bashbuddy.cart.domain.models.CartItem
import com.devi3east.bashbuddy.cart.domain.repositories.CartRepository
import com.devi3east.bashbuddy.cart.results.CheckoutResult
import com.devi3east.bashbuddy.purchase.requests.PurchaseInitRequest
import com.devi3east.bashbuddy.purchase.requests.PurchaseItemRequest
import com.devi3east.bashbuddy.purchase.responses.PurchaseConfirmResponse

class CartRepositoryImpl(
    private val api: CartApi
) : CartRepository {

    override suspend fun checkout(
        token: String,
        items: List<CartItem>,
        jurisdictionEligibilityConfirmed: Boolean
    ): CheckoutResult {
        return try {
            val requestItems = items.map { cartItem ->
                val donationRaw = cartItem.ticket.donation
                val shippingFeeCents = if (cartItem.shippingSelected) cartItem.ticket.shippingFee else 0L
                val unitAmountCents = donationRaw + shippingFeeCents
                PurchaseItemRequest(
                    eventId = cartItem.ticket.eventId!!,
                    ticketId = cartItem.ticket._id,
                    quantity = cartItem.quantity,
                    shippingSelected = cartItem.shippingSelected,
                    unitAmountCents = unitAmountCents
                )
            }
            val request = PurchaseInitRequest(
                items = requestItems,
                jurisdictionEligibilityConfirmed = jurisdictionEligibilityConfirmed
            )
            val response = api.checkout(token, request)
            response
        } catch (e: Exception) {
            CheckoutResult.Failure(e)
        }
    }

    override suspend fun confirmPurchase(
        token: String,
        sessionId: String,
    ): Result<PurchaseConfirmResponse> {
        return try {
            val response = api.confirmPurchase(token, sessionId)
            Result.success(response)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

}